import { ItfSubscribe, ItfSubscribeTip } from './type';

const getSubscribeCommon = (email: string, locale: string, value: number[]): ItfSubscribe => {
    const localMap: { [key: string]: string[] } = {
        us: ['4423', '9625'],
        ca: ['4424', '9626'],
    };
    const arr: string[] = localMap?.[locale] || localMap.us;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    return {
        source: 'WEB_NEW_PRODUCT_SUB',
        contactListId: '1487185288',
        email,
        fields: [
            {
                type: 'single',
                id: arr[0],
                value: 1,
                overwrite: true,
            },
            {
                type: 'single',
                id: '31',
                value: 1,
                overwrite: false,
            },
            {
                type: 'multiple',
                id: '9435',
                value: value,
                overwrite: false,
            },
            {
                type: 'text',
                id: arr[1],
                value: dateString,
                overwrite: false,
            },
        ],
    };
};

export const getSubscribe = (type: string, email: string, locale: string) => {
    switch (type) {
        case 'BATTERY_BACKUP':
            return getSubscribeCommon(email, locale, [9]);
        case 'COST_SAVING':
            return getSubscribeCommon(email, locale, [10]);
        case 'ON_THE_ROAD':
            return getSubscribeCommon(email, locale, [23]);
        case 'LIVING_OFF_GRID':
            return getSubscribeCommon(email, locale, [12]);
        case 'RVING_ROAD_TRIPS':
            return getSubscribeCommon(email, locale, [11]);
        case 'OUTDOOR_RECRATION':
            return getSubscribeCommon(email, locale, [13]);
        case 'DISASTER_PREPAREDNESS':
            return getSubscribeCommon(email, locale, [57]);
        case 'WHOLE_HOME_POWER':
            return getSubscribeCommon(email, locale, [66]);
    }
};

export const getTermsLink = (locale: string) => {
    const map: { [key: string]: string[] } = {
        us: ['https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html'],
        ca: ['https://account.ecoflow.com/agreement/en-ca/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-ca/TermsOfUse.html'],
        au: ['https://account.ecoflow.com/agreement/en-au/PrivacyPolicy.html', 'https://account.ecoflow.com/agreement/en-au/TermsOfUse.html'],
    };
    return map?.[locale] || map.us;
};

export const TIP_EMAIL_EMPTY = 'Please enter your email address.';
export const TIP_EMAIL_ILLEGAL = 'Please enter a valid email address (Example: name@domain.com).';
export const TIP_CHECKBOX = "Please read and agree to EcoFlow's Privacy Policy and Terms of Use";
export const TIP_SUCCESS = 'Thanks for your subscription!';

export const INIT_TIP: ItfSubscribeTip = {
    type: 'error',
    text: '',
};
